// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y5vc","col":"styles_col__1GNy0","actions":"styles_actions__cM2qw","conflict":"styles_conflict__3nAFl"};